import { useSyncExternalStore } from 'react'
import { chatListStore } from '@/features/chat/api/chatClient'

/**
 * Shared conversation-list state for the chat tab and the nav badge —
 * the PWA counterpart of reading mobile's shared `ChatListProvider`.
 * Side-effect free: the list screen owns hydrate/load/session (WU3).
 */
export function useConversations() {
  const snapshot = useSyncExternalStore(chatListStore.subscribe, chatListStore.getSnapshot)
  return { ...snapshot, store: chatListStore }
}
